import * as React from 'react';
import { Product } from '~/Api/Product';
import { HrMaxPrice } from '~/Api/User/ProductGroup/HrMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		hrMaxPrice: HrMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ hrMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => hrMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[hrMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'HrMaxPrice.ProductProvider';
